var sha256 = require('crypto-js/sha256')
var hmacSHA256 = require('crypto-js/hmac-sha256')

function formattedNow() {
  function pad(element) {
    return element <= 9 ? '0' + element : element
  }

  var date = new Date()
  return `${date.getUTCFullYear()}${pad(date.getUTCMonth() + 1)}${pad(date.getUTCDate())}T${pad(date.getUTCHours())}${pad(date.getUTCMinutes())}${pad(date.getUTCSeconds())}Z`
}

function uriEncoded(uri, encodeSlash) {
  var result = ''
  for (var i = 0; i < uri.length; i++) {
    var ch = uri.charAt(i)
    if (
      (ch >= 'A' && ch <= 'Z') ||
      (ch >= 'a' && ch <= 'z') ||
      (ch >= '0' && ch <= '9') ||
      ch == '_' ||
      ch == '-' ||
      ch == '~' ||
      ch == '.' ||
      ch == '&' ||
      ch == '='
    ) {
      result += ch
    } else if (ch == '/') {
      result += encodeSlash ? '%2F' : ch
    } else {
      // eslint-disable-next-line no-undef
      result += hex(ch)
    }
  }
  return result.toString()
}

function getHashedCanonicalRequest(
  httpVerb,
  serviceUri,
  queryString,
  headers,
  payload
) {
  var canonicalURI = serviceUri
  var canonicalQueryString = uriEncoded(queryString).toString()

  var canonicalHeaders = ''
  var signedHeaders = ''
  for (var i = 0; i < headers.length; i++) {
    canonicalHeaders += `${headers[i][0]}:${headers[i][1]}\n`
    signedHeaders += `${headers[i][0]};`
  }
  signedHeaders = signedHeaders.slice(0, -1)

  var hashedPayload = sha256(payload).toString()
  var canonical = `${httpVerb}\n${canonicalURI}\n${canonicalQueryString}\n${canonicalHeaders}\n${signedHeaders}\n${hashedPayload}`

  return sha256(canonical).toString()
}

function getStringToSign(
  algorithm,
  datetime,
  date,
  region,
  service,
  hashedCanonicalRequest
) {
  return `${algorithm}\n${datetime}\n${date}/${region}/${service}/aws4_request\n${hashedCanonicalRequest}`
}

function getSignature(secretKey, date, region, service, stringToSign) {
  const kDate = hmacSHA256(date, 'AWS4' + secretKey)
  const kRegion = hmacSHA256(region, kDate)
  const kService = hmacSHA256(service, kRegion)
  const kSigning = hmacSHA256('aws4_request', kService)

  return hmacSHA256(stringToSign, kSigning).toString()
}

function getAuthorisation(
  algorithm,
  accessKey,
  date,
  region,
  service,
  signedHeaders,
  signature
) {
  return `${algorithm} Credential=${accessKey}/${date}/${region}/${service}/aws4_request, SignedHeaders=${signedHeaders}, Signature=${signature}`
}

function getAuthorisationHeader(
  accessKey,
  secretKey,
  verb,
  uri,
  query,
  headers,
  payload,
  date,
  datetime,
  region,
  service
) {
  var algorithm = 'AWS4-HMAC-SHA256'
  var signedHeaders = ''
  headers.sort()
  for (var i = 0; i < headers.length; i++) {
    signedHeaders += `${headers[i][0]};`
  }
  signedHeaders = signedHeaders.slice(0, -1)

  var hashedCanonicalRequest = getHashedCanonicalRequest(
    verb,
    uri,
    query,
    headers,
    payload
  )
  var stringToSign = getStringToSign(
    algorithm,
    datetime,
    date,
    region,
    service,
    hashedCanonicalRequest
  )
  var signature = getSignature(secretKey, date, region, service, stringToSign)
  var authorisation = getAuthorisation(
    algorithm,
    accessKey,
    date,
    region,
    service,
    signedHeaders,
    signature
  )
  return authorisation
}

function getCredentials(identityId) {
  var xmlHttp = new XMLHttpRequest()
  xmlHttp.open('POST', 'https://www.totallymoney.com/cognito/')
  xmlHttp.setRequestHeader(
    'x-amz-target',
    'AWSCognitoIdentityService.GetCredentialsForIdentity'
  )
  xmlHttp.setRequestHeader('content-type', 'application/x-amz-json-1.1')
  xmlHttp.send(JSON.stringify({ IdentityId: identityId }))

  return new Promise(function (resolve, reject) {
    xmlHttp.onload = function () {
      if (xmlHttp.status >= 200 && xmlHttp.status < 300) {
        var response = JSON.parse(xmlHttp.responseText)
        resolve(response.Credentials)
      } else {
        reject({
          status: xmlHttp.status,
          statusText: xmlHttp.statusText,
        })
      }
    }
  })
}

function putRecordBatch(deliveryStream, records, credentials) {
  records.forEach(function (item, index) {
    this[index].Data = btoa
      ? btoa(unescape(encodeURIComponent(item.Data)))
      : Buffer.from(item.Data, 'binary').toString('base64')
  }, records)

  var payload = JSON.stringify({
    DeliveryStreamName: deliveryStream,
    Records: records,
  })
  var now = formattedNow()

  var xmlHttp = new XMLHttpRequest()
  xmlHttp.open('POST', 'https://firehose.eu-west-2.amazonaws.com/')
  xmlHttp.setRequestHeader('x-amz-content-sha256', sha256(payload).toString()),
    xmlHttp.setRequestHeader('x-amz-date', now),
    xmlHttp.setRequestHeader('x-amz-security-token', credentials.SessionToken)
  xmlHttp.setRequestHeader('x-amz-target', 'Firehose_20150804.PutRecordBatch')
  xmlHttp.setRequestHeader('x-amz-user-agent', 'aws-sdk-js/2.606.0 promise')
  xmlHttp.setRequestHeader('content-type', 'application/x-amz-json-1.1')

  var authorisationHeader = getAuthorisationHeader(
    credentials.AccessKeyId,
    credentials.SecretKey,
    'POST',
    '/',
    '',
    [
      ['host', 'firehose.eu-west-2.amazonaws.com'],
      ['x-amz-content-sha256', sha256(payload).toString()],
      ['x-amz-date', now],
      ['x-amz-security-token', credentials.SessionToken],
      ['x-amz-target', 'Firehose_20150804.PutRecordBatch'],
      ['x-amz-user-agent', 'aws-sdk-js/2.606.0 promise'],
    ],
    payload,
    now.substring(0, 8),
    now,
    'eu-west-2',
    'firehose'
  )

  xmlHttp.setRequestHeader('authorization', authorisationHeader)
  xmlHttp.send(payload)

  return new Promise(function (resolve, reject) {
    xmlHttp.onload = function () {
      if (xmlHttp.status >= 200 && xmlHttp.status < 300) {
        var response = JSON.parse(xmlHttp.responseText)
        resolve(response)
      } else {
        reject({
          status: xmlHttp.status,
          statusText: xmlHttp.statusText,
        })
      }
    }
  })
}

module.exports = {
  getCredentials,
  putRecordBatch,
}
